import { render } from "./ModalPdfViewer.vue?vue&type=template&id=4187bfc0"
import script from "./ModalPdfViewer.vue?vue&type=script&lang=js"
export * from "./ModalPdfViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__